(() => {
 'use strict';
 let stop=()=>{};
 function init(){
  stop();
  const layer=document.querySelector('.vx4-breeze');if(!layer)return;
  const wrapper=layer.parentElement;let cancelled=false,observer;
  const load=src=>new Promise((resolve,reject)=>{const img=new Image();img.onload=resolve;img.onerror=reject;img.src=src;});
  Promise.all([load(layer.dataset.wall),load(layer.dataset.leaves)]).then(()=>{
   if(cancelled||!layer.isConnected)return;
   wrapper.classList.add('vx4-breeze-ready');
  }).catch(()=>{});
  const hero=document.querySelector('.vxh-hero');
  if(hero&&'IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{layer.dataset.visible=String(entries[0].isIntersecting);},{threshold:0});observer.observe(hero);}else layer.dataset.visible='true';
  stop=()=>{cancelled=true;observer?.disconnect();};
 }
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('shopify:section:unload',init);
 init();
})();
